import React from "react";
import { STATUS_TONES } from "./tokens";

/**
 * Small colored status pill.
 * Accepts either a known status key (pending, delivered, in_progress...) or an explicit tone override.
 */
export function StatusBadge({ status, label, size = "sm", testid }) {
  const key = (status || "").toLowerCase();
  const tone = STATUS_TONES[key] || STATUS_TONES.pending;
  const sz = size === "lg"
    ? "text-xs px-3 py-1"
    : "text-[10px] px-2 py-0.5";
  return (
    <span
      data-testid={testid || `status-${key}`}
      className={`inline-flex items-center gap-1 rounded-full font-bold uppercase tracking-wider whitespace-nowrap ${tone.bg} ${tone.text} ${sz}`}
    >
      {label || tone.label}
    </span>
  );
}
